import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import Header from './components/Header4';
import Footer from './components/Footer4';

const FAQs = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        {
            category: 'Orders & Shopping',
            questions: [
                {
                    question: 'How do I place an order?',
                    answer: 'Browse our collection, add items to your cart, and proceed to checkout. You\'ll need to create an account or sign in to complete your purchase. Follow the prompts to enter your shipping and payment information, then review and confirm your order.'
                },
                {
                    question: 'Can I modify or cancel my order?',
                    answer: 'Orders can be modified or canceled within 2 hours of placement. After this window, orders enter our processing system and cannot be changed. Please contact our customer service team immediately if you need to make changes.'
                },
                {
                    question: 'What payment methods do you accept?',
                    answer: 'We accept all major credit/debit cards, UPI, net banking, and Cash on Delivery (COD). All payments are processed securely through our payment gateway.'
                },
            ],
        },
        {
            category: 'Shipping & Delivery',
            questions: [
                {
                    question: 'How long does delivery take?',
                    answer: 'Standard delivery takes 5-7 business days across India. Express delivery (2-3 business days) is available for an additional charge. Custom and bridal orders may take 2-4 weeks depending on the design complexity.'
                },
                {
                    question: 'Do you ship internationally?',
                    answer: 'Yes, we ship to select international destinations. International shipping typically takes 10-15 business days. Shipping charges and customs duties are calculated at checkout.'
                },
                {
                    question: 'Is shipping free?',
                    answer: 'We offer free standard shipping on all orders above \u20B95,000 within India. Orders below this amount incur a flat \u20B9199 shipping charge.'
                },
            ],
        },
        {
            category: 'Returns & Exchanges',
            questions: [
                {
                    question: 'What is your return policy?',
                    answer: 'We accept returns within 7 days of delivery for unused items in original packaging. Custom-made and bridal items are non-returnable. Please ensure items have all tags attached and are in unworn condition.'
                },
                {
                    question: 'How do I initiate a return?',
                    answer: 'Log into your account, go to My Orders, select the item you wish to return, and follow the return process. Our team will arrange a pickup from your address within 2-3 business days.'
                },
            ],
        },
        {
            category: 'Product & Care',
            questions: [
                {
                    question: 'Are your products authentic handloom?',
                    answer: 'Yes, all our handloom products come with a certificate of authenticity. We work directly with weaver communities and ensure genuine handwoven textiles. Each product page mentions the specific craft technique used.'
                },
                {
                    question: 'How should I care for silk sarees?',
                    answer: 'We recommend dry cleaning for all silk sarees. Store them in muslin cloth to allow the fabric to breathe. Avoid direct sunlight for prolonged periods. Detailed care instructions are included with each product.'
                },
            ],
        },
    ];

    let globalIndex = 0;

    return (
        <div className="w-full min-h-screen bg-white" style={{ fontFamily: "'Work Sans', sans-serif" }}>
            <Header />
            <link href="https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />

            <main className="pt-20 md:pt-24">
                {/* Hero */}
                <div className="bg-[#F0F7FA] py-10 md:py-16 px-4 text-center">
                    <p className="text-xs tracking-[0.2em] uppercase mb-2 text-[#62B6CB] font-medium">Help Center</p>
                    <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-[#1B4965] mb-3">Frequently Asked Questions</h1>
                    <p className="text-sm md:text-base text-[#6B7280] max-w-lg mx-auto font-light">
                        Find answers to common questions about our products, orders, and policies
                    </p>
                </div>

                <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
                    {faqs.map((section) => (
                        <div key={section.category} className="mb-10">
                            <h2 className="text-lg font-semibold text-[#1B4965] mb-4 pb-2 border-b border-[#E5E7EB]">
                                {section.category}
                            </h2>
                            <div className="space-y-2">
                                {section.questions.map((faq) => {
                                    const idx = globalIndex++;
                                    const isOpen = openIndex === idx;
                                    return (
                                        <div key={idx} className="border border-[#E5E7EB] rounded-sm overflow-hidden">
                                            <button
                                                onClick={() => setOpenIndex(isOpen ? null : idx)}
                                                className="w-full flex items-center justify-between px-4 py-4 text-left bg-white hover:bg-[#F0F7FA] transition-colors"
                                            >
                                                <span className="text-sm font-medium text-[#1A1A1A] pr-4">{faq.question}</span>
                                                {isOpen ? (
                                                    <ChevronUp className="w-4 h-4 text-[#1B4965] flex-shrink-0" />
                                                ) : (
                                                    <ChevronDown className="w-4 h-4 text-[#6B7280] flex-shrink-0" />
                                                )}
                                            </button>
                                            {isOpen && (
                                                <div className="px-4 pb-4">
                                                    <p className="text-sm text-[#6B7280] leading-relaxed">{faq.answer}</p>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default FAQs;
